// Cal.com block schema - Embed a Cal.com booking button
export const calComSchema = {
  type: 'cal-com',
  label: 'Cal.com',
  description: 'Embed a Cal.com booking button',
  icon: 'Calendar',
  defaultContent: {
    calComUrl: '',
    buttonText: 'Schedule a Meeting',
    style: {},
  },
  fields: [
    { name: 'calComUrl', label: 'Cal.com URL', type: 'text', placeholder: 'https://cal.com/your-name/meeting', required: true },
    { name: 'buttonText', label: 'Button Text', type: 'text', placeholder: 'Schedule a Meeting' },
  ],
};
